import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export const NavLogo = () => {
  return (
    <Link
      to="/"
      aria-label="RAKB"
      className="flex items-center flex-shrink-0 group transition-all duration-200 -ml-2 sm:-ml-3"
    >
      <Logo
        size="lg"
        color="text-green-night group-hover:text-green"
        className="transition-colors duration-200 w-10 h-10 sm:w-12 sm:h-12"
      />
    </Link>
  );
};
